var PartnerType;
(function (PartnerType) {
    PartnerType["InboundApi"] = "insulet";
    PartnerType["Redox"] = "redox";
    PartnerType["PartnerApi"] = "api";
    PartnerType["CommercialAPI"] = "commercialapi";
    // TODO: adjust this with correct type from connection
    PartnerType["PumpPartner"] = "pumppartner";
})(PartnerType || (PartnerType = {}));
export default PartnerType;
